import { render, staticRenderFns } from "./ProjectEditTitle.vue?vue&type=template&id=222ed5b5&scoped=true&"
import script from "./ProjectEditTitle.vue?vue&type=script&lang=js&"
export * from "./ProjectEditTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222ed5b5",
  null
  
)

export default component.exports